<template>
    <div :class="[{'mr-5 mb-5': !isPrint}]">
        <table :class="[{'width100perc': $vuetify.breakpoint.xsOnly || isPrint},
                        {'font12': !isPrint}, {'font9': isPrint}, ]">
            <tbody>
                <tr v-if="!isPrint">
                    <td class="actionCell"/>
                    <td :colspan="spielResult.showSVSpalte?3:2" style="background-color: #f2f2f2"
                        :class="[{'font14': !isPrint},{'font10': isPrint},'borderLeftTopBottom']">
                        <span class="font-weight-bold grey--text text--darken-2 pl-1">
                            <span v-if="spiel.label">{{spiel.label}}</span>
                            <span v-else>SPIEL {{spiel?.id}}</span>
                        </span>
                    </td>
                    <td :colspan="spielResult.showSVSpalte?3:2" class="text-right borderRightTopBottom"
                        style="background-color: #f2f2f2">
                        <span v-if="spiel.bahn1 && spiel.bahn2">
                            <!--{{ spiel.startZeit }} - -->Bahn {{ spiel.bahn1 }}/{{ spiel.bahn2 }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td v-if="isOperator" rowspan="3" style="padding: 0; vertical-align: top"
                        class="borderLeftTopBottom text-center actionCell">
                        <div>
                        <v-btn icon @click="editSpielResult()"
                               :disabled="!spiel.team1 || !spiel.team2 || bewerbIsConfirmed">
                            <v-icon :color="spielResult.winnerTeam?'success':'primary'">mdi-bowling</v-icon>
                        </v-btn>
                        </div>
                        <v-btn icon @click="clearSpiel()"
                               :disabled="bewerbIsConfirmed || (!spiel.hasFreilos() && !spiel.team1 && !spiel.team2)">
                            <v-icon :color="spielResult.winnerTeam?'success':'primary'">mdi-delete</v-icon>
                        </v-btn>
                    </td>
                    <td v-else-if="isPrint" rowspan="3" class="actionCell borderAll text-center">
                        <span v-if="spiel.label" class="font-weight-bold">{{spiel.label}}</span>
                        <span v-else class="font-weight-bold">SPIEL {{spiel?.id}}</span>
                        <!--<div>{{ spiel.startZeit }}</div>-->
                        <div v-if="spiel.bahn1">Bahn {{ spiel.bahn1 }}/{{ spiel.bahn2 }}</div>
                    </td>
                    <td v-else rowspan="3" class="actionCell"/>
                </tr>
                <tr :class="[{'font14': !isPrint}, {'font10': isPrint && !isDoppel}, {'font9': isPrint && isDoppel},
                             'font-weight-bold grey--text text--darken-2 text-center']">
                    <spiel-ko-team :teamKey="'team1'" :spielResult="spielResult" :spiel="spiel" :is-operator="isOperator"
                                   :teamLabel="teamLabel" @editTeam="editTeam" :bewerb-is-confirmed="bewerbIsConfirmed"
                                   :is-print="isPrint"/>
                    <spiel-ko-team :teamKey="'team2'" :spielResult="spielResult" :spiel="spiel" :is-operator="isOperator"
                                   :teamLabel="teamLabel" @editTeam="editTeam" :bewerb-is-confirmed="bewerbIsConfirmed"
                                   :is-print="isPrint"/>
                </tr>
                <tr v-if="!hideKegelCells" class="text-center">
                    <td class="borderLeftTopBottom kegel">Kegel</td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom kegel">SV</td>
                    <td class="borderAll sp">SP</td>
                    <td class="borderLeftTopBottom kegel">Kegel</td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom kegel">SV</td>
                    <td class="borderAll sp">SP</td>
                </tr>
                <tr v-if="!hideKegelCells"  v-for="(satz, i) in spiel.getSaetzeList()" :key="i" class="text-center">
                    <td class="borderAll actionCell">
                        <span>{{1 + (settingsSpiel.wuerfeProSatz * i)}}</span>
                        <span>-</span>
                        <span>{{settingsSpiel.wuerfeProSatz * (i+1)}}</span>
                    </td>
                    <td class="borderLeftTopBottom">{{ isNaN(satz.k1)?'-':satz.k1 }}</td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom">{{ satz.sv1 }}</td>
                    <td class="borderAll">{{satz.getSatzPunkte(1)}}</td>
                    <td class="borderLeftTopBottom">{{ isNaN(satz.k2)?'-':satz.k2 }}</td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom">{{ satz.sv2 }}</td>
                    <td class="borderAll">{{satz.getSatzPunkte(2)}}</td>
                </tr>
                <tr v-if="spielResult.showSpielSV && !hideKegelCells" class="text-center">
                    <td class="borderAll actionCell">SV</td>
                    <td class="borderLeftTopBottom"></td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom">{{spiel.sv1}}</td>
                    <td class="borderAll">{{spielResult.spSv1}}</td>
                    <td class="borderLeftTopBottom"></td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom">{{spiel.sv2}}</td>
                    <td class="borderAll">{{spielResult.spSv2}}</td>
                </tr>
                <tr v-if="!hideKegelCells"  class="text-center font-weight-bold">
                    <td class="actionCell"/>
                    <td class="borderLeftTopBottom">{{ isNaN(spielResult.kegel1)?'-':spielResult.kegel1 }}</td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom">{{ spiel.sv1 }}</td>
                    <td class="borderAll">{{ spielResult.sp1 }}</td>
                    <td class="borderLeftTopBottom">{{ isNaN(spielResult.kegel2)?'-':spielResult.kegel2 }}</td>
                    <td v-if="spielResult.showSVSpalte" class="borderTopBottom">{{ spiel.sv2 }}</td>
                    <td class="borderAll">{{ spielResult.sp2 }}</td>
                </tr>
                <tr v-if="spiel.kommentar">
                    <td class="actionCell"/>
                    <td :colspan="spielResult.showSVSpalte?6:4" style="max-width: 40px; line-height: 1.4;"
                        class="borderAll pl-2 py-2 primary--text font-weight-bold" >
                        {{spiel.kommentar}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import SpielKoTeam from "@/views/ergebnisdienst/meisterschaft/spiele/spielKoTeam.vue";

export default {
    name: "spielKo",
    components: {SpielKoTeam},
    props: ['spiel', 'settingsSpiel', 'teamLabel', 'bewerbIsConfirmed', 'isOperator', 'isPrint'],
    computed: {
        spielResult(){ return this.spiel.getSpielResult(this.settingsSpiel) },
        hideKegelCells(){ return this.spiel.hasFreilos() || !this.spiel.teamsAreSet() ||
                (this.spiel.team1 && this.spiel.team1.settings.name === 'FREILOS') || !this.spiel.winner },
        isDoppel(){
            return this.spiel?.team1?.settings?.name?.indexOf('/') !== -1 ||
                   this.spiel?.team2?.settings?.name?.indexOf('/') !== -1;
        },
    },
    methods: {
        editTeam(args){
            this.$emit('editTeam', args);
        },
        editSpielResult(){
            this.$emit('editSpielResult', this.spiel);
        },
        clearSpiel(){
            this.$emit('clearSpiel', this.spiel);
        }
    },
}
</script>

<style scoped>
    table {
        border-collapse: collapse;
        border-spacing: 0;
        letter-spacing: 0.5px;
    }
    .actionCell {
        min-width: 56px;
    }
    .borderAll {
        border: 1px solid grey;
    }
    .borderLeftTopBottom {
        border-left: 1px solid grey;
        border-top: 1px solid grey;
        border-bottom: 1px solid grey;
    }
    .borderRightTopBottom {
        border-right: 1px solid grey;
        border-top: 1px solid grey;
        border-bottom: 1px solid grey;
    }
    .borderTopBottom {
        border-top: 1px solid grey;
        border-bottom: 1px solid grey;
    }
    th, td {
        padding: 1px 4px;
    }
    .font9 {font-size: 9px;}
    .font10 {font-size: 10px;}
    .font12 {font-size: 12px;}
    .font14 {font-size: 14px;}
    .kegel {min-width: 42px;}
    .sp {min-width: 32px;}
    .width100perc{width: 100%;}

</style>